import React from 'react'
import styled from 'styled-components'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { useEmojiNameToDisplayMap } from 'hooks/useEmojiState'
// @ts-ignore
import { Dialog, Tooltip } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { CountTypeStrings } from 'enums/CountType'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import messageUtil from 'utils/messageUtil'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import { getDisplayText, resolveTooltip } from './utils'

const DIALOG_CONTENT_HEIGHT = '460px'

const Name = styled.span`
  font-weight: ${sys.fontWeight.semibold};
`

interface InsightModalProps {
  open: boolean
  onClose: () => void
  title?: string
  countType?: CountTypeStrings
  selectedInsights?: InsightData[]
  detailSetting?: InsightContentSettingType
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  widgetSettingWithSelection?: any
  viewOption?: InsightViewOptionStrings
}

const InsightModal = ({
  open,
  title,
  countType,
  selectedInsights,
  onClose,
  detailSetting,
  timeUnits,
  forceNotScale,
  widgetSettingWithSelection,
  viewOption
}: InsightModalProps) => {
  const theme = useDisplayTheme() as Theme
  const emojiNameToDisplayMap = useEmojiNameToDisplayMap()

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        {selectedInsights?.map((item: InsightData, index: number) => (
          <StyledTermContainer
            // eslint-disable-next-line react/no-array-index-key
            key={`${item.name}-${index}`}>
            <Tooltip
              mode={theme}
              enabled
              content={resolveTooltip(item, viewOption!, emojiNameToDisplayMap!)}>
              <StyledTermContent
                // eslint-disable-next-line react/no-array-index-key
                key={`${item.name}}-${index}`}
                mode={theme}>
                {getDisplayText(item.name!, viewOption!, emojiNameToDisplayMap!)}
              </StyledTermContent>
            </Tooltip>
          </StyledTermContainer>
        ))}
        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
          countType={countType}
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SUMMARY),
              accordionContents: [
                {
                  insightContentType: InsightContentType.TOTAL_MEASURE,
                  detailSetting
                },
                {
                  insightContentType: InsightContentType.NAME_MEASURE,
                  detailSetting,
                  renderNameMeasureTitleContent: () => (
                    <>
                      <Name>
                        {detailSetting?.selectionName &&
                          getDisplayText(
                            detailSetting.selectionName,
                            viewOption!,
                            emojiNameToDisplayMap
                          )}
                      </Name>
                      &nbsp;
                      {messageUtil.countType(countType!)}
                    </>
                  )
                }
              ]
            },
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.SOUND_BITE),
              accordionContents: [
                {
                  insightContentType: InsightContentType.SOUND_BITE,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
